import { User } from "firebase/auth";
import { FirebaseInit } from "./firebaseinit";
import { Action } from "../../base/lib/abstract/patterns";


export class OptionalFirebaseUser {

    private user: User | null = null;
    private userAvailableActions: Action[] = [];

    constructor(private firebase: FirebaseInit) {
        this.firebase.f_auth.registerListener((user) => this.updateUser(user));
    }

    public isEmpty() {
        return this.user == null;
    }

    private updateUser(user: User | null) {
        //Maybe we abort when user is changed?
        if (user != this.user) {
            this.user = user;
            if (user != null) {
                for (let action of this.userAvailableActions) {
                    action(false);
                }
                this.userAvailableActions = [];
            }
        }
    }

    public getUser(): Promise<User> {
        return new Promise((resolve, exception) => {
            if (this.user != null) {
                resolve(this.user);
            } else {
                this.userAvailableActions.push((b) => { resolve(this.user as User); return true; });
            }
        });
    }



}